import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Coffee, X } from "lucide-react";
import api from "../../lib/api";
import { money } from "../../lib/format";

export default function OpenShiftModal({ outletId, onOpened, onClose }) {
  const { t } = useTranslation();
  const [cash, setCash] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async () => {
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/shifts/open", {
        outlet_id: outletId,
        opening_cash: parseInt(cash || "0", 10) || 0,
      });
      onOpened(data);
    } catch (e) {
      setError(e?.response?.data?.detail?.message || "Failed to open shift");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex items-center justify-center p-4">
      <div
        className="bg-card border border-border w-full max-w-sm rounded-2xl p-6 shadow-2xl space-y-5 relative"
        data-testid="open-shift-modal"
      >
        {onClose && (
          <button
            type="button"
            onClick={onClose}
            aria-label={t("Close")}
            data-testid="open-shift-close"
            className="absolute top-3 right-3 w-9 h-9 rounded-lg flex items-center justify-center text-muted-foreground hover:text-foreground hover:bg-secondary transition"
          >
            <X size={20} />
          </button>
        )}

        <div className="text-center">
          <div className="w-14 h-14 rounded-2xl bg-primary/15 text-primary flex items-center justify-center mx-auto">
            <Coffee size={26} />
          </div>
          <h3 className="font-heading text-lg font-bold mt-3">{t("Open Cashier Shift")}</h3>
          <p className="text-sm text-muted-foreground">
            {t("Opening shift description")}
          </p>
        </div>

        {error && (
          <p className="text-sm text-red-400 bg-red-500/10 border border-red-500/30 rounded-lg px-3 py-2">
            {error}
          </p>
        )}

        <input
          data-testid="opening-cash-input"
          type="number"
          inputMode="numeric"
          value={cash}
          onChange={(e) => setCash(e.target.value)}
          placeholder={t("Opening cash placeholder")}
          className="w-full h-14 px-4 rounded-xl bg-secondary border border-border focus:border-primary focus:outline-none font-mono text-xl font-bold text-center"
          autoFocus
        />

        <button
          onClick={submit}
          disabled={busy}
          data-testid="open-shift-button"
          className="w-full h-12 rounded-xl bg-primary text-primary-foreground font-bold hover:opacity-90 active:scale-[0.98] transition disabled:opacity-40"
        >
          {busy
            ? t("Opening…")
            : `${t("Open Shift")}${cash ? ` · ${money(parseInt(cash, 10) || 0)}` : ""}`}
        </button>
      </div>
    </div>
  );
}
